import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { updatedocuments } from '@store/slice/documentsSlice'
import { get } from '@util/xhrAPI'
import { updateNotification } from '@store/slice/mainSlice'
import useDynamicForm from '@hook/useDynamicForm'
import useDeleteButton from '@hook/useDeleteButton'
import useDownloadFile from '@hook/useDownloadFile'
import { useTranslation } from 'react-i18next'
import { useTheme } from '@table-library/react-table-library/theme'
import { getTheme } from '@table-library/react-table-library/baseline'
import {
  Table,
  Header,
  HeaderRow,
  Body,
  Row,
  HeaderCell,
  Cell,
} from "@table-library/react-table-library/table"
import Alert from '@ui/elements/Alert'
import Div from '@ui/layout/Div'
import Buttons from '@ui/elements/Buttons'

const ListDocument = () => {
  const { documents } = useSelector(state => state.documents || { documents: [] })
  const { mission } = useSelector(state => state.main)
  const theme = useTheme(getTheme())
  const toggleDynamicForm = useDynamicForm()
  const dispatch = useDispatch()
  const [t] = useTranslation('common')
  const deleteButton = useDeleteButton()
  const datadocuments = { nodes: [] }
  const downLoadFile = useDownloadFile()

  if (documents) {
    datadocuments.nodes = Object.values(documents)
  }

  const removeDocument = item => {
    const { id, links } = item
    get(`${import.meta.env.VITE_API_URL}${links.remove}`, response => {
      const { code } = response
      if (code === 200) {
        const document = documents[id]
        const documentsList = { ...documents }
        delete documentsList[id]
        dispatch(updatedocuments({ ...documentsList }))
        dispatch(updateNotification({ type: 'is-success', message: t('messages.removed_successfuly', { title: document.name }) }))
      } else {
        dispatch(updateNotification({ type: 'is-danger', message: t('messages.error_occured') }))
      }
    })
  }

  useEffect(() => {
    get(`${import.meta.env.VITE_API_URL}/api/missions/${mission.id}/documents`, response => {
      const { documents } = response;
      dispatch(updatedocuments(documents))
    });
  }, [])

  return (
    <Div cssClass='documents-list'>
      <h2 className='scene-title'>{t('titles.list_documents')}</h2>
      <Div cssClass='actions-zone'>
        <Buttons buttons={{
          icon: 'icon-add',
          cssClass: 'is-info is-small',
          callback: () => toggleDynamicForm('document'),
          text: t('actions.add')
        }}
        />
      </Div>
      {null !== documents && datadocuments.nodes.length
        ? <>
          <Table data={datadocuments} theme={theme}>
            {(tableList) => (
              <>
                <Header>
                  <HeaderRow>
                    <HeaderCell>{t('table.Document')}</HeaderCell>
                    <HeaderCell></HeaderCell>
                  </HeaderRow>
                </Header>
                <Body>
                  {tableList.map(item =>
                    <Row key={item.id} item={item}>
                      <Cell>{item.name}</Cell>
                      <Cell className='table-actions'>
                        <Buttons buttons={[
                          {
                            icon: 'icon-download',
                            cssClass: 'is-info is-small',
                            callback: () => downLoadFile(`${import.meta.env.VITE_API_URL}${item.links.download}`, item.name, 'pdf')
                          }
                        ]} />
                        {deleteButton(item.id, item.name, removeDocument)}
                      </Cell>
                    </Row>
                  )}
                </Body>
              </>
            )}
          </Table>
        </>
        : <Alert type='is-info' message={t('messages.empty_list')} />
      }
    </Div>
  )
}

export default ListDocument